import React from 'react'
import styled from '@emotion/styled'

import { fontSize2XSmall, fontSize3XSmall } from '../../constants/principles'
import TwoButtonModal from '../generic/modals/TwoButtonModal'
import { ModalContentNormal } from '../generic/Basics.js'
import { QuestionUtils } from '../../utils/siteUtils'

export default ({ getSelectedVehicleModifications, showModal, getQuestionAnswerValues, getQuestionResponseComment, getQuestionResponse, amQ, saveQuestionResponse, removeVehicleModifications }) => {
  return (
    <TwoButtonModal
      testId={'vd-modal-vehicle-modification'}
      name={'VehicleModifications'}
      title={"Some of your responses don't match."}
      subtitle={'You previously said your vehicle had one or more modifications. If you choose "No" now, it will remove the following modifications.'}
      open={showModal}
      positiveCopyOverride={'Keep Modifications'}
      negativeCopyOverride={'Remove Modifications'}
      onClickPositive={e => saveQuestionResponse(amQ, 0)}
      onClickNegative={e => removeVehicleModifications()}>
      <FontSizedContentDiv>
        Vehicle Modification(s) you selected:
        <OptionDiv>
          {getSelectedVehicleModifications().map((section, index) => {
            return (
              <div key={index}>
                <SubsectionHeader>{section.subsection}</SubsectionHeader>
                {section.questions.map((q, index2) => {
                  const comment = getQuestionResponseComment(q.questionId)
                  const answer = getQuestionAnswerValues(q)
                  const multi = q.questionType === 'MultiSelect' && answer.length
                  const data = (
                    <React.Fragment key={index2}>
                      <StyledLabel>{q.label}</StyledLabel>
                      {multi ? (
                        q.selectChoices.map((choice, index3) => {
                          const answered = QuestionUtils.isQuestionAnswered(getQuestionResponse(choice.qRef).v)
                          const rcomment = answered && getQuestionResponseComment(choice.qRef)
                          const multiData = answered && (
                            <React.Fragment key={index3}>
                              <StyledValue>{choice.value}</StyledValue>
                              {rcomment && <StyledValue>Explanation: {rcomment}</StyledValue>}
                            </React.Fragment>
                          )
                          return multiData
                        })
                      ) : (
                        <>
                          <StyledValue>{answer}</StyledValue>
                          {comment && <StyledValue>Explanation: {comment}</StyledValue>}
                        </>
                      )}
                    </React.Fragment>
                  )
                  return data
                })}
              </div>
            )
          })}
        </OptionDiv>
      </FontSizedContentDiv>
    </TwoButtonModal>
  )
}

const FontSizedContentDiv = styled(ModalContentNormal)`
  padding-top: 8px;
  font-size: ${fontSize2XSmall};
  font-weight: bold;
`
const OptionDiv = styled.div`
  padding-top: 8px;
  padding-bottom: 16px;
`
const SubsectionHeader = styled.div`
font-weight:bold;+
`
const StyledLabel = styled.div`
  font-size: ${fontSize3XSmall};
  font-weight: bold;
`
const StyledValue = styled.div`
  font-size: ${fontSize3XSmall};
  font-weight: normal;
`
